import confirm from '../confirm/confirm.vue'

export default {
  name: 'AppHeader',
  components: {
    confirm
  },
  data () {
    return {}
  },
  computed: {
    isLoggedIn () {
      return this.$store.state.session.isLoggedIn
    }
  },
  methods: {
    async logout () {
      const confirmed = await this.$refs.confirm.open('Logout', 'Are you sure you want to logout?', { color: 'primary', confirm: 'Yes', cancel: 'Cancel' })
      if (confirmed) {
        this.$store.dispatch('logout')
        this.$router.push({ name: 'Login' })
      }
    }
  }
}
